export async function transformBookContent(res) {
  const content = await new Response(res).arrayBuffer();
  const textBufView = new Uint8Array(content);
  const key = "$+(hT5-?#k8D^*N3";
  const keyLen = key.length;
  for (let i = 0; i < textBufView.length; i++) {
    textBufView[i] = textBufView[i] ^ key.charCodeAt(i % keyLen);
  }
  return Utf8ArrayToStr(textBufView);
}

function Utf8ArrayToStr(array) {
  var out, i, len, c;
  var char2, char3;
  out = "";
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
        break;
    }
  }
  return out;
}

export function setToStorage(key, value) {
  if (key) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
}

export function getFromStorage(key) {
  if (key) {
    const item = localStorage.getItem(key);
    return JSON.parse(item);
  }
  return null;
}
